import React, { Component } from 'react';
import DiagramsView from '../views/DiagramsView';
import { base } from '../../base';

class DiagramsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            diagrams: [],
        };
    }

    componentDidMount() {
        this.refData = base.syncState(`diagrams/${this.props.extraUser.companyid}`, {
            context: this,
            asArray: true,
            state: 'diagrams',
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.refData);
    }

    render() {
        return (
            <DiagramsView
                diagrams={this.state.diagrams}
                user={this.props.user}
                extraUser={this.props.extraUser}
            />
        );
    }
}

export default DiagramsContainer;



// WEBPACK FOOTER //
// ./src/components/containers/DiagramsContainer.js